module.exports = __webpack_public_path__ + "img/ic_medium_artikel.c39253a4.svg";